import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import TagManager, {TagManagerArgs} from 'react-gtm-module';
import {createRoot} from 'react-dom/client'

const tagManagerArgs: TagManagerArgs = {
    gtmId: 'GTM-MHJKFLF',
};

TagManager.initialize(tagManagerArgs)
const container = document.getElementById('root');
const root = createRoot(container!)

root.render(<App />)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
